import request from '@/utils/request';
import { fileService } from "@/api/common/file-utils";
import commonFun from "@/utils/commonFun";

export const list = (data) => {
    return request({
        url: `/calibration/list`,
        method: 'post',
        data: data
    });
};
export const getDetailBySp = (sensoryCalibrationId) => {
    return request({
        url: `/calibration/infoSp/${sensoryCalibrationId}`,
        method: 'post',
    });
};
export const getDetail = (sensoryCalibrationId) => {
    return request({
        url: `/calibration/${sensoryCalibrationId}`,
        method: 'get',
    });
};
export const getDetailByCqs = (sensoryCalibrationId) => {
    return request({
        url: `/calibration/infoCqs/${sensoryCalibrationId}`,
        method: 'post',
    });
};
export const saveBySp = (data) => {
    return request({
        url: `/calibration/spSave`,
        method: 'post',
        data: data,
    });
};
export const saveByCQS = (data) => {
    return request({
        url: `/calibration/cqsSave`,
        method: 'post',
        data: data,
    });
};
export const save = (data) => {
    return request({
        url: `/calibration/save`,
        method: 'post',
        data: data,
    });
};
export const inactive = (ids, reason) => {
    return request({
        url: `/calibration/inactive`,
        method: 'post',
        data: {
            ids: commonFun.convertToArray(ids),
            inactiveReason: reason
        },
    });
};
export const getSourceScore = (sensoryCalibrationId, ttSensoryReportId) => {
    return request({
        url: `/calibration/getSourceScore/${sensoryCalibrationId}`,
        method: 'post',
        data: ttSensoryReportId,
    });
};

export const calibration = (sensoryCalibrationId) => {
    return request({
        url: `/calibration/calibration`,
        method: 'post',
        data: sensoryCalibrationId,
    });
};
export const exportExcel = (data) => {
    return request({
        url: `/calibration/export`,
        method: 'post',
        data: data,
        responseType: 'blob',
        fullResponse: true
    }).then(fileService.respToFile);
};

export const downloadCertificate = (id) => {
    return request({
        url: `/calibration/downloadCertificate`,
        method: 'post',
        data: id,
        responseType: 'blob',
        fullResponse: true
    }).then(fileService.respToFile);
};
export const sendCertificates = (id) => {
    return request({
        url: `/calibration/sendCertificates`,
        method: 'post',
        data: id,
    });
};
export const sendMail = (data) => {
    return request({
        url: `/calibration/sendMail`,
        method: 'post',
        data: data,
    });
};
export const getTemplateByFiveBitCode = (templateId) => {
    return request({
        url: `/calibration/getTemplateInfoByTemplateId/${templateId}`,
        method: 'get',
    });
};

export default {
    list: list,
    // getDetailBySp:getDetailBySp,
    getDetail: getDetail,
    // getDetailByCqs:getDetailByCqs,
    // saveBySp:saveBySp,
    // saveByCQS:saveByCQS,
    save: save,
    inactive: inactive,
    getSourceScore: getSourceScore,
    sendMail: sendMail,
    calibration: calibration,
    exportExcel: exportExcel,
    downloadCertificate: downloadCertificate,
    sendCertificates: sendCertificates,
}